require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
//New template
Vue.component('front-header-new', require('./components/header/frontHeaderNew.vue').default);
Vue.component('front-header-landing', require('./components/header/frontHeaderLanding.vue').default);
Vue.component('front-header-retoma', require('./components/header/frontHeaderRetoma.vue').default);
Vue.component('front-header-ficha', require('./components/header/frontHeaderFicha.vue').default);
Vue.component('front-footer-new', require('./components/footer/frontFooterNew.vue').default);
Vue.component('front-header-comingsoon', require('./components/header/frontHeader503.vue').default);
Vue.component('front-footer-comingsoon', require('./components/footer/frontFooter503.vue').default);
//Containers
Vue.component('front-login', require('./modules/frontend/auth/frontLogin.vue').default);
Vue.component('front-pass', require('./modules/frontend/auth/forgot_pass.vue').default);
Vue.component('front-restablecer', require('./modules/frontend/auth/form_pass.vue').default);

Vue.component('front-home', require('./modules/frontend/inicio/frontHomeContainer.vue').default);
Vue.component('front-acercade', require('./modules/frontend/acercade/frontAcercadeContainer.vue').default);
Vue.component('front-servicios', require('./modules/frontend/servicios/frontServiciosContainer.vue').default);
Vue.component('front-contacto', require('./modules/frontend/contacto/frontContactoContainer.vue').default);
Vue.component('front-comprar', require('./modules/frontend/comprar/frontComprarContainer.vue').default);
Vue.component('front-vender', require('./modules/frontend/vender/frontVenderContainer.vue').default);
Vue.component('front-financiar', require('./modules/frontend/financiar/frontFinanciarContainer.vue').default);
Vue.component('front-test_drive', require('./modules/frontend/testDrive/frontTestDriveContainer.vue').default);
Vue.component('front-configuracion', require('./modules/frontend/configuracion/frontConfiguracionContainer.vue').default);
Vue.component('front-detalle', require('./modules/frontend/detalleVehiculo/frontDetalleContainer.vue').default);
Vue.component('front-propuesta', require('./modules/frontend/propuesta/frontPropuestaContainer.vue').default);
Vue.component('front-solicitudcredito', require('./modules/frontend/solicitud_credito/frontSolicitudContainer.vue').default);
Vue.component('front-terminos-condiciones', require('./modules/frontend/terminos_condiciones/frontTerminosCondicionesContainer.vue').default);
Vue.component('front-politica-datos', require('./modules/frontend/politica_datos/frontPoliticaDatosContainer.vue').default);
Vue.component('front-cotizacion', require('./modules/frontend/cotizacion/frontCotizacionContainer.vue').default);
Vue.component('front-fichainspeccion', require('./modules/frontend/fichaInspeccion/frontFichaInspeccionContainer.vue').default);
Vue.component('icon-flotante', require('./components/footer/iconFlotante.vue').default);

Vue.component('front-ofertar', require('./modules/frontend/detalleVehiculoRetoma/frontOfertarContainer.vue').default);

// Retomas
Vue.component('front-misretomas', require('./modules/frontend/retoma/frontMisRetomasContainer.vue').default);
Vue.component('front-ofertas', require('./modules/frontend/retoma/frontOfertasContainer.vue').default);
Vue.component('front-perfil', require('./modules/frontend/retoma/frontMiPerfilContainer.vue').default);
Vue.component('front-reportar', require('./modules/frontend/retoma/frontReporteContainer.vue').default);



Vue.component('front-tramite', require('./modules/frontend/tramite/frontTramiteContainer.vue').default);
//Vue.component('front-inventario', require('./modules/frontend/inventario/frontInventarioContainer.vue').default);
Vue.component('pagina-construccion', require('./components/construccion/construccionContainer.vue').default);

import { store } from 'store/main-store';

//Loader global
Vue.component('clip-loader', require('vue-spinner/src/ClipLoader.vue').default);
Vue.component('vue-autonumeric', require('vue-autonumeric/src/components/VueAutonumeric.vue').default);
Vue.component('VueSimpleRangeSlider', require('vue-simple-range-slider').default);

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import bFormSlider from 'vue-bootstrap-slider';
var numeral = require('numeral');

Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
});
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';



Vue.use(VueSweetalert2);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(bFormSlider)

const app = new Vue({
  el: '#app',
  store
});
